<div class="flex flex-column align-center text-center ids-mt-10">
  @if (isLoading) {
    <div class="flex flex-column align-center justify-center">
      <h2 class="ids-heading-l">Logga ut</h2>
      <p class="ids-preamble">Utloggning pågår, var god vänta.</p>
      <id-spinner srtext="Laddar"></id-spinner>
    </div>
  } @else {
    <h1 class="ids-heading-xxl">Du har blivit utloggad.</h1>
    <div class="ids-mt-10">
      <id-button-group>
        <id-button size="l" (click)="navigateToStart()"> <button>Återgå till start</button></id-button>
        <id-button size="l" (click)="login()"><button>Logga in igen</button></id-button>
      </id-button-group>
    </div>
  }
</div>
